module.exports = __webpack_public_path__ + "static/media/822aae179a9ac336.2f6b40ab.png";